<template>
  <Appendix
    title="Biên bản thu hồi"
    :fields="fieldsTable"
    :actions="actions"
    :excepts="excepts"
    :only="only"
    :items="items"
    :contract="contract"
  >
    <template #row-details="item">
      <div>Lý do thu hồi: {{ item.appendixRecall.recallReason }}</div>
      <DeviceInfoAppendix :items="item.appendixRecall.deviceRecalls" :fields="deviceFields">
      </DeviceInfoAppendix>
      <LocationInfoAppendixVue :items="[item.appendixRecall]" />
    </template>
    <template #file="item">
      <div v-if="item.urlPDF" class="form-detail">
        <UploadMultiple
          v-if="item.urlPDF"
          :lsData="[item]"
          keyUrl="urlPDF"
          :canUpload="false"
          :title="`File biên bản ${item.code}`"
          titleTag="h1"
          titleClass="form-inner-heading"
        />
        <UploadMultiple
          v-if="
            item.appendixRecall.evidenceUrls ? item.appendixRecall.evidenceUrls.length > 0 : false
          "
          :lsData="item.appendixRecall.evidenceUrls"
          :canUpload="false"
          :title="'Ảnh chụp live'"
          titleTag="h1"
          titleClass="form-inner-heading"
        />
      </div>
    </template>
  </Appendix>
</template>
<script>
  import Appendix from './Appendix.vue'
  import DeviceInfoAppendix from './DeviceInfoAppendix.vue'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  import LocationInfoAppendixVue from './LocationInfoAppendix.vue'
  export default {
    props: {
      actions: {
        type: Function,
      },
      excepts: {
        type: Array,
        default: () => [],
      },
      only: {
        type: Array,
        default: () => [],
      },
      items: {
        type: Array,
        default: () => [],
      },
      contract: {
        type: Object,
        default: () => {},
      },
    },
    components: { Appendix, DeviceInfoAppendix, UploadMultiple, LocationInfoAppendixVue },
    data() {
      return {
        fieldsTable: [
          { key: 'code', label: 'Mã biên bản', class: 'text-left' },
          {
            key: 'time',
            label: 'Thời gian',
            class: 'text-left',
            thStyle: 'min-width: 210px',
          },
          { key: 'numDevices', label: 'SL thiết bị', class: 'text-right' },
          { key: 'state', label: 'Trạng thái', class: 'text-center' },
          { key: 'action', label: 'Thao tác', class: 'text-center' },
        ],
        deviceFields: [
          { key: 'device.displayName', label: 'Tên thiết bị', class: 'text-left' },
          { key: 'device.serialNumber', label: 'Mã serial', class: 'text-left' },
          { key: 'deviceState', label: 'Tình trạng sử dụng', class: 'text-right' },
        ],
      }
    },
  }
</script>

<style scoped></style>
